import * as React from 'react';
import { useGetList, LinearProgress } from 'react-admin';
import SMeter from '../SMeter';

const AppVersionCount = ({ style = {} }) => {
	const { data: eventData, isError, isLoading } = useGetList(
		'AppEvent',
		{
			pagination: { page: 1, perPage: 1000 },
			sort: { field: 'dateTime', order: 'DESC' },
			filter: { name: 'appOpened' },
		},
	);

	if (!isLoading && isError) { return 'error'; }

	if (isLoading) { return <LinearProgress />; }

	if (!eventData) { return 'no event data'; }

	const data = eventData.reduce(
		(a, v) => {
			const appVersion = v.params.nativeApplicationVersion;
			return a.set(appVersion, a.has(appVersion) ? a.get(appVersion) + 1 : 1);
		},
		new Map(),
	);
	const array = Array.from(data.entries())
		.sort(([k1], [k2]) => k1.localeCompare(k2, 'ru'));
	const values = array.map(([, v]) => v);
	const labels = array.map(([v]) => `${v}`);

	return (
		<SMeter
			data={values}
			labels={labels}
			style={style}
			title="Версии приложения"
		/>
	);
};

export default AppVersionCount;
